import { hydrate } from "react-dom"
import { onElementInView } from "./utils/inView"
import { onElementInteract } from "./utils/interact"

const getComponentName = node => node.dataset.reactClass
const once = (fn, context) => { 
	let result;

	return function() { 
		if (fn) {
			result = fn.apply(context || this, arguments)
			fn = null
		}
		return result
	}
}

const importComponent = componentName => {
  return new Promise((resolve, reject) => import(
    /* webpackInclude: /AvvoQuestion|Histogram|DivorceGuide|FamilyBasedGreenCardGuide|ParentingPlanGuide|PrenuptialGuide|UsCitizenshipGuide/ */
    /* webpackChunkName: "[request]" */
    /* webpackMode: "lazy" */
    `../components/${componentName}`)
    .then(component => resolve(component.default))
    .catch(err => {
      console.warn(`Failed to load ${componentName}`, err)
      reject(err)
    })
  )
}

const hydrateComponent = (component, node, additionalProps = {}) => {
  const props = {
    ...JSON.parse(node.dataset.reactProps || {}),
    ...additionalProps,
  }
  const element = React.createElement(component, props)
  return hydrate(element, node)
} 

const importWhenInViewAndHydrate = (componentName, node) => {
  const elementInView = onElementInView(node, once(() => {
    elementInView.unobserve()

    return importComponent(componentName)
      .then(component => {
        hydrateComponent(component, node)
      })
  }))
}

const importWhenInteractAndHydrate = (componentName, node) => {
  const elementInteract = onElementInteract(node, once(e => {
    elementInteract.removeEventListeners()

    importComponent(componentName)
      .then(component => {
        if (component.setEventBeforeImportHandler) {
          component.setEventBeforeImportHandler(e)
        }
        hydrateComponent(component, node)
      })
  }))
}

document.addEventListener('DOMContentLoaded', () => {
  const reactComponents = [...document.querySelectorAll("[data-react-class]")]
  reactComponents.forEach(node => {
    const componentName = getComponentName(node)

    if (node.dataset.lazyLoadOn == 'interact') {
      importWhenInteractAndHydrate(componentName, node)
    } else {
      importWhenInViewAndHydrate(componentName, node)
    }
  })
})
